// ENUMS
import { Status } from '../enums/proposal-status.enum';
import { Themes } from '../enums/themes';

// Master Payroll Loan default selected statuses
// propostas em andamento (FORMALIZATION), aguardando selfie (AWAITING_SIGNATURE), com pendências (PENDING_DOCUMENTS_SIGN)
const MASTER_PAYROLL_LOAN_STATUSES = [Status.FORMALIZATION, Status.AWAITING_SIGNATURE, Status.PENDING_DOCUMENTS_SIGN];

export const getStatusOptionsForUser = (user: any) => {
  // Check if user has MASTER_PAYROLLLOAN in profileTypes
  const hasMasterPayrollLoan =
    user && user.profileTypes && Array.isArray(user.profileTypes) && user.profileTypes.includes('MASTER_PAYROLLLOAN');

  const baseStatusOptions = [
    {
      id: 0,
      badgeType: Themes.PRIMARY,
      name: Status.AWAITING_SIGNATURE,
      label: 'Aguardando ass.',
      active: true,
    },
    {
      id: 1,
      badgeType: Themes.DEFAULT,
      name: Status.FORMALIZATION,
      label: 'Em análise.',
      active: true,
    },
    {
      id: 2,
      badgeType: Themes.SECONDARY,
      name: Status.MADE_EFFECTIVE,
      label: 'Efetivado.',
      active: true,
    },
    {
      id: 3,
      badgeType: Themes.INFO,
      name: Status.REJECTED,
      label: 'Negado.',
      active: true,
    },
    {
      id: 4,
      badgeType: Themes.WARNING,
      name: Status.PENDING_DOCUMENTS,
      label: 'Pendência Doc.',
      active: true,
    },
    {
      id: 5,
      badgeType: Themes.WARNING,
      name: Status.PENDING_SIGN,
      label: 'Pendência Ass.',
      active: true,
    },
    {
      id: 6,
      badgeType: Themes.WARNING,
      name: Status.PENDING_DOCUMENTS_SIGN,
      label: 'Pendências.',
      active: true,
    },
    {
      id: 7,
      badgeType: Themes.INFO,
      name: Status.REFUSED,
      label: 'Recusado.',
      active: true,
    },
    {
      id: 8,
      badgeType: Themes.DEFAULT,
      name: Status.ENDORSED,
      label: 'Em Análise.',
      active: true,
    },
    {
      id: 9,
      badgeType: Themes.WARNING,
      name: Status.PENDING_PURCHASE_MARGIN,
      label: 'Pendência Margem',
      active: true,
    },
    {
      id: 10,
      badgeType: Themes.WARNING,
      name: Status.PENDING_PURCHASE_MARGIN_WRONG_PROPOSAL,
      label: 'Margem Prop. Errada',
      active: true,
    },
    {
      id: 11,
      badgeType: Themes.DEFAULT,
      name: Status.REFUSED_EXPIRED,
      label: 'Expirado',
      active: true,
    },
  ];

  // If user has MASTER_PAYROLLLOAN in profileTypes, set only specific statuses as active
  if (hasMasterPayrollLoan) {
    return baseStatusOptions.map((option) => ({
      ...option,
      active: MASTER_PAYROLL_LOAN_STATUSES.includes(option.name),
    }));
  }

  // Otherwise, return all statuses as active (default behavior)
  return baseStatusOptions;
};
